import { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../modules/Authentication';
import { NotificationBell } from '../modules/Notifications';
import { VerticalNavigation, VerticalNavLink } from './VerticalNavigation';
import { DegradationBanner } from '../modules/Operations';
import { TermsGate } from '../modules/Terms';
import { usePageTitle } from './usePageTitle';
import { useFeatureFlags } from '../modules/FeatureFlags';
import { FeatureFlagName } from '../modules/FeatureFlags/constants/featureFlagNames';
import './UserLayout.css';

const NAV_ITEMS = [
    { name: 'dashboard', iconName: 'chart-pie', label: 'داشبورد', end: true },
    { name: 'kyc', iconName: 'shield-star', label: 'احراز هویت' },
    { name: 'certificates', iconName: 'document', label: 'گواهی‌ها', flag: FeatureFlagName.CERTIFICATE_ISSUE_ENABLED },
    { name: 'sign-pdf', iconName: 'pen', label: 'امضای PDF', flag: FeatureFlagName.PDF_SIGNING_ENABLED },
    { name: 'signing-history', iconName: 'clock-filled', label: 'تاریخچه امضا', flag: FeatureFlagName.PDF_SIGNING_ENABLED },
    { name: 'activity-logs', iconName: 'clock-outline', label: 'فعالیت‌ها' },
    { name: 'evidence', iconName: 'document-duplicate', label: 'مدارک', flag: FeatureFlagName.EVIDENCE_ENABLED },
    { name: 'tickets', iconName: 'ticket', label: 'تیکت‌ها', flag: FeatureFlagName.TICKETING_ENABLED },
    { name: 'payments', iconName: 'card', label: 'پرداخت‌ها', flag: FeatureFlagName.PAYMENTS_ENABLED },
];

function UserLayout() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const { isEnabled } = useFeatureFlags();

    const handleLogout = async () => {
        await logout();
        navigate('/login');
    };

    const closeSidebar = () => setSidebarOpen(false);

    const initials = user?.firstName
        ? user.firstName.charAt(0) + (user.lastName?.charAt(0) || '')
        : 'U';

    const pageTitle = usePageTitle(NAV_ITEMS, (item) => `/${item.name}`);

    const visibleNavItems = NAV_ITEMS.filter((item) => {
        if (item.flag) return isEnabled(item.flag);
        return true;
    });

    const items = visibleNavItems.map(({ name, iconName, label, end }) => ({
        name,
        component: () => (
            <VerticalNavLink href={`/${name}`} iconName={iconName} end={end}>
                {label}
            </VerticalNavLink>
        ),
    }));

    return (
        <div className="user-layout">
            {/* Mobile topbar */}
            <div className="mobile-topbar">
                <button className="mobile-menu-btn" onClick={() => setSidebarOpen(true)}>☰</button>
                <span className="mobile-topbar-title">سامانه گواهی دیجیتال</span>
                <div className="mobile-topbar-actions">
                    <NotificationBell scope="user" />
                    <div className="sidebar-avatar">{initials}</div>
                </div>
            </div>

            {/* Overlay */}
            <div className={`sidebar-overlay ${sidebarOpen ? 'visible' : ''}`} onClick={closeSidebar} />

            {/* Sidebar */}
            <VerticalNavigation
                className={sidebarOpen ? 'open' : ''}
                items={items}
                profileHref="/profile"
                setupGuideHref="/guide/user"
                helpHref="/help/user"
                onLogout={handleLogout}
            />

            <main className="user-layout-main">
                <DegradationBanner />
                <header className="user-topbar">
                    <span className="user-topbar-title"></span>
                    <div className="user-topbar-actions">
                        <NotificationBell scope="user" />
                    </div>
                </header>
                <Outlet />
            </main>
            <TermsGate />
        </div>
    );
}

export default UserLayout;